(() => {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function asString(value) {
    return value == null ? '' : String(value).trim();
  }

  function getDynamicShareData(root) {
    const fallbackTitle = root.dataset.shareTitle || document.title || 'Unisource Apparel';
    const fallbackUrl = root.dataset.shareUrl || window.location.href;

    try {
      if (
        window.InksoftPOC &&
        window.InksoftPOC.productPage &&
        typeof window.InksoftPOC.productPage.getShareData === 'function'
      ) {
        const productShare = window.InksoftPOC.productPage.getShareData();

        if (productShare && productShare.url) {
          return {
            title: productShare.title || fallbackTitle,
            url: productShare.url || fallbackUrl,
            hasArtwork: Boolean(productShare.hasArtwork),
            source: 'inksoft-product-page'
          };
        }
      }
    } catch (error) {
      console.warn('[Unisource Social Share] Product share data unavailable. Using page URL.', error);
    }

    return {
      title: fallbackTitle,
      url: fallbackUrl,
      hasArtwork: false,
      source: 'page'
    };
  }

  ready(() => {
    const root = document.querySelector('[data-unisource-social-share]');
    if (!root) return;

    const trigger = root.querySelector('[data-share-trigger]');
    const panel = root.querySelector('[data-share-panel]');
    const close = root.querySelector('[data-share-close]');
    const status = root.querySelector('[data-share-status]');

    const facebook = root.querySelector('[data-share-facebook]');
    const instagram = root.querySelector('[data-share-instagram]');
    const x = root.querySelector('[data-share-x]');
    const linkedin = root.querySelector('[data-share-linkedin]');
    const email = root.querySelector('[data-share-email]');
    const copy = root.querySelector('[data-share-copy]');

    function setStatus(message) {
      if (!status) return;
      status.textContent = message || '';
    }

    function getShareDataAndSyncLinks() {
      const share = getDynamicShareData(root);
      const title = asString(share.title) || 'Unisource Apparel';
      const url = asString(share.url) || window.location.href;

      const encodedUrl = encodeURIComponent(url);
      const encodedTitle = encodeURIComponent(title);
      const bodyLabel = share.hasArtwork
        ? `${title}\n\nView this product preview with the selected artwork:\n${url}`
        : `${title}\n\n${url}`;

      if (facebook) {
        facebook.href = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
      }

      if (x) {
        x.href = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
      }

      if (linkedin) {
        linkedin.href = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
      }

      if (email) {
        email.href = `mailto:?subject=${encodedTitle}&body=${encodeURIComponent(bodyLabel)}`;
      }

      if (trigger) {
        trigger.setAttribute(
          'title',
          share.hasArtwork ? 'Share this product preview' : 'Share this page'
        );
      }

      return {
        title,
        url,
        hasArtwork: share.hasArtwork
      };
    }

    function openPanel() {
      if (!panel || !trigger) return;

      const share = getShareDataAndSyncLinks();

      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');

      setStatus(
        share.hasArtwork
          ? 'Sharing this product preview with the selected artwork.'
          : ''
      );
    }

    function closePanel() {
      if (!panel || !trigger) return;
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      setStatus('');
    }

    function togglePanel() {
      if (!panel) return;
      panel.hidden ? openPanel() : closePanel();
    }

    trigger?.addEventListener('click', async () => {
      const share = getShareDataAndSyncLinks();
      const canNativeShare = Boolean(navigator.share);

      if (canNativeShare && window.matchMedia('(max-width: 749px)').matches) {
        try {
          await navigator.share({
            title: share.title,
            url: share.url
          });
          return;
        } catch (error) {
          // User cancelled or native share failed. Fall back to panel.
        }
      }

      togglePanel();
    });

    close?.addEventListener('click', closePanel);

    instagram?.addEventListener('click', async () => {
      const share = getShareDataAndSyncLinks();

      try {
        await navigator.clipboard.writeText(share.url);
        setStatus(
          share.hasArtwork
            ? 'Preview link copied for Instagram. Paste it into your caption, story, or DM.'
            : 'Link copied for Instagram. Paste it into your caption, story, or DM.'
        );
      } catch (error) {
        setStatus('Copy failed. Please copy the URL from your browser.');
      }
    });

    copy?.addEventListener('click', async () => {
      const share = getShareDataAndSyncLinks();

      try {
        await navigator.clipboard.writeText(share.url);
        setStatus(share.hasArtwork ? 'Product preview link copied.' : 'Link copied.');
      } catch (error) {
        setStatus('Copy failed. Please copy the URL from your browser.');
      }
    });

    [facebook, x, linkedin, email].forEach((link) => {
      link?.addEventListener('click', () => {
        getShareDataAndSyncLinks();
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closePanel();
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) closePanel();
    });

    getShareDataAndSyncLinks();
  });
})();